interface IProps {
    onClick?: () => void;
    size?: number
    color?: string
}

export const Redeemed = (props: IProps) => {
    const { onClick, size, color } = props;

    return (
        <svg width={size || 16} height={size || 16} viewBox="0 0 15 14" fill={color || "none"} xmlns="http://www.w3.org/2000/svg">
            <path d="M7.50016 0.333333C3.8335 0.333333 0.833496 3.33333 0.833496 7C0.833496 10.6667 3.8335 13.6667 7.50016 13.6667C11.1668 13.6667 14.1668 10.6667 14.1668 7C14.1668 3.33333 11.1668 0.333333 7.50016 0.333333ZM10.3668 5.4L7.30016 9.4C7.16683 9.53333 6.96683 9.66667 6.76683 9.66667C6.56683 9.66667 6.36683 9.6 6.2335 9.4L4.6335 7.33333C4.4335 7.06667 4.4335 6.6 4.76683 6.4C5.10016 6.2 5.50016 6.2 5.70016 6.53333L6.76683 7.93333L9.30016 4.6C9.50016 4.33333 9.96683 4.26667 10.2335 4.46667C10.5668 4.66667 10.5668 5.06667 10.3668 5.4Z" fill="#336C51" />
        </svg>

    );
};
